module.exports = __webpack_public_path__ + "img/logo.0297a3f0.png";